import { useDispatch } from "react-redux";
import { setPrintaction } from "../../../../../redux/printstate/printActions";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import baseUrl from "../../../../../api/baseUrl";
function ControllerTraw({ target, api,action }: any) {
  const dispatch = useDispatch();

  const handleClick = (e: any) => {
    dispatch(
      action({ name: target?.title, target: e?.target, value: e.value })
    );

    baseUrl
      .patch(api, {
        name: target?.title,
        target: e?.target,
        value: e.value,
      })
      .then((response) => {})
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <tr>
      <td>{target?.name}</td>
      <td>
        <button
          onClick={() =>
            handleClick({ target: "left", value: target.left - 1 })
          }
        >
          <ChevronLeftIcon />
        </button>
        <button
          onClick={() =>
            handleClick({ target: "left", value: target.left + 1 })
          }
        >
          <ChevronRightIcon />
        </button>
        <button
          onClick={() => handleClick({ target: "top", value: target.top - 1 })}
        >
          <KeyboardArrowUpIcon />
        </button>
        <button
          onClick={() => handleClick({ target: "top", value: target.top + 1 })}
        >
          <KeyboardArrowDownIcon />
        </button>
      </td>
      <td>
        {target.name === "container" ? (
          <>
            <span>height:{target.top}px</span>
            <span>width:{target.left}px</span>
          </>
        ) : (
          <>
            <span>top:{target.top}px</span>
            <span>left:{target.left}px</span>
            <span>size:{target.size}px</span>
          </>
        )}
      </td>
      <td>
        <button
          onClick={() =>
            handleClick({ target: "size", value: target.size + 1 })
          }
        >
          <KeyboardArrowUpIcon />
        </button>
        <button
          onClick={() =>
            handleClick({ target: "size", value: target.size - 1 })
          }
        >
          <KeyboardArrowDownIcon />
        </button>
      </td>
      <td>
        <button
          onClick={() => handleClick({ target: "show", value: !target.show })}
        >
          {target.show ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </button>
      </td>
    </tr>
  );
}

export default ControllerTraw;
